import React from 'react';
import { useSelector } from 'react-redux';

import AvatarComponent from '../AvatarComponent/AvatarComponent';
import { timeAgo } from '@/utils/ts/stringUtils';

interface RefreshStatsNotificationInterface {
  title: string;
}

const RefreshStatsNotification: React.FC<RefreshStatsNotificationInterface> = ({ notification }: any) => {
  const { userProfile } = useSelector((state: any) => state.user);

  return (
    <div className={`single-notification ${notification?.seen && 'seen'}`}>
      <div className='unread-dot'></div>
      <div className="avatar-div">
        <AvatarComponent
          src={userProfile?.profile_link}
          alt={userProfile?.first_name + ' ' + userProfile?.last_name || ''}
        />
      </div>
      <div className="text-div" style={{ marginLeft: 6 }}>
        <h3 className="title">{notification?.title || "Your creator insights for All Influencers are up to date!"}</h3>
        <p className="description">{notification?.description}</p>
        <p className="timestamp" style={{ paddingTop: 8 }}>
          {timeAgo(notification?.createdAt)}
        </p>
      </div>
    </div>
  );
};

export default RefreshStatsNotification;
